import { SportType } from '@utils/planTypes';

/**
 * `sport_type.identifier` (V2) → the V1 `SportType` vocabulary, which every icon, colour and
 * translation helper already speaks. Mapping rather than duplicating keeps one set of labels.
 */
const TO_LEGACY: Record<string, SportType> = {
  RUNNING: 'running',
  SWIMMING: 'swimming',
  CYCLING: 'cycling',
  PPG: 'ppg',
};

export const legacySportOf = (sportIdentifier: string | null): SportType =>
  TO_LEGACY[sportIdentifier ?? ''] ?? 'repos';

/** R44: the competition is no longer a session, so every session row has a sport of its own. */
export const sportOfSession = (sportIdentifier: string | null): SportType => legacySportOf(sportIdentifier);
